import React, { Component } from 'react'
import MenuSider from '../../../../components/MenuSider'
import { Bar, Pie } from 'react-chartjs-2';
import { Checkbox, Button, Spin } from 'antd';
import { Constants, Odata_2_Url } from '../../../../Constants/Constants'
import { Select, Collapse } from 'antd';
import 'chartjs-plugin-labels';
import { Col, Row } from 'react-bootstrap';
import IntlMessages from '../../../../util/IntlMessages';

const Panel = Collapse.Panel;
const Option = Select.Option;

function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const Initial_Count_Nearmiss = 0
const Initial_Count_Unsafe_Killer = 0
const Initial_Count_Observation_All = 0

const month_list = [{ "monthName": <IntlMessages id='January' />, "order": 1 },
{ "monthName": <IntlMessages id='February' />, "order": 2 },
{ "monthName": <IntlMessages id='March' />, "order": 3 },
{ "monthName": <IntlMessages id='April' />, "order": 4 },
{ "monthName": <IntlMessages id='May' />, "order": 5 },
{ "monthName": <IntlMessages id='June' />, "order": 6 },
{ "monthName": <IntlMessages id='July' />, "order": 7 },
{ "monthName": <IntlMessages id='August' />, "order": 8 },
{ "monthName": <IntlMessages id='September' />, "order": 9 },
{ "monthName": <IntlMessages id='October' />, "order": 10 },
{ "monthName": <IntlMessages id='November' />, "order": 11 },
{ "monthName": <IntlMessages id='December' />, "order": 12 }]

export default class All extends Component {

    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeChk_all = this.handleChangeChk_all.bind(this)
        this.handleChangeMonth = this.handleChangeMonth.bind(this);

        this.loadData = this.loadData.bind(this);

        var year_now_ = new Date().getFullYear()
        let month_now = new Date().getMonth() + 1

        this.state = {
            chartData: {},
            unsafe_killer: Initial_Count_Unsafe_Killer,
            nearmiss: Initial_Count_Nearmiss,
            observation_All: Initial_Count_Observation_All,
            data1: 1,
            year_now: year_now_,
            dataObservation: [],
            select_year: new Date().getFullYear(),
            select_month: [month_now],

            chkAll: false,
            shown: 'none',

            company_socard: '',
            company_target: '',
            percentSOTCompany: '',
            pieData: {},
            barData: {},
            barData_2: {},
            onLoading: false,
            pieLabel: {
                plugins: {
                    labels: {
                        render: function (args) {
                            return args.label + ', ' + args.value + ', ' + args.percentage + '%';
                        },
                        fontSize: 14,
                        fontStyle: 'bold'
                    }
                }
            },
            barLabel: {
                showLines: false,
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            autoSkip: false,
                            maxRotation: 90,
                            minRotation: 90
                        },
                    }]
                },
                legend: {
                    labels: {
                        boxWidth: 50,
                        fontSize: 10
                    }
                },
                plugins: {
                    labels: {
                        render: 'value'
                    }
                }
            }

        }
    }

    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng) {
            this.setState({ isEng: isEng })
            this.set_data_bar(this.state.safeData)
            this.set_data_bar_2(this.state.unSafeData)
            this.set_data(this.state.pieDataTemp.safeNumber, this.state.pieDataTemp.unSafeNumber)
        }
    }

    componentWillMount() {
        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })
        this.loadData();
    }

    set_data(safe, unsafe) {
        this.setState({
            pieData: {
                labels: this.state.isEng ? ['Safe', 'Unsafe'] : ['ปลอดภัย', 'ไม่ปลอดภัย'],
                datasets: [{
                    data: [safe, unsafe],
                    showInLegend: true,
                    backgroundColor: [
                        'rgba(75,220,150,0.5)',
                        'rgba(255,99,132,0.5)',

                    ],
                    borderColor: [
                        'rgba(75,220,150,1)',
                        'rgba(255,99,132,1)',

                    ],
                    borderWidth: 0.2
                }]
            }
        })
    }

    set_data_bar(data) {
        var jobType = JSON.parse(window.localStorage.getItem('Jobtype'))
        let job_detail = data.map(l => {
            return this.state.isEng ? (jobType.find(x => x.JobType1.trim() === l.job_detail) || {}).Short_detail_EN : l.job_detail
        })
        this.setState({
            barData:
            {
                labels: job_detail,
                datasets: [
                    {
                        label: 'Number Of Safe',
                        backgroundColor: 'rgba(75,220,150,0.2)',
                        borderColor: 'rgba(75,220,150,1)',
                        borderWidth: 1,
                        data: [data[0].jobdetailNumber, data[1].jobdetailNumber, data[2].jobdetailNumber]
                    }
                ]
            }
        })
    }

    set_data_bar_2(data) {
        var jobType = JSON.parse(window.localStorage.getItem('Jobtype'))
        let job_detail = data.map(l => {
            return this.state.isEng ? (jobType.find(x => x.JobType1.trim() === l.job_detail) || {}).Short_detail_EN : l.job_detail
        })
        this.setState({
            barData_2:
            {
                labels: job_detail,
                datasets: [
                    {
                        label: 'Number Of UnSafe',
                        backgroundColor: 'rgba(255,99,132,0.2)',
                        borderColor: 'rgba(255,99,132,1)',
                        borderWidth: 1,
                        data: [data[0].jobdetailNumber, data[1].jobdetailNumber, data[2].jobdetailNumber]
                    }
                ]
            }
        })
    }
    handleChange(value) {
        this.setState({ select_year: value });
        this.loadData();
    }

    handleChangeMonth(value) {
        this.setState({
            select_month: value
        })
    }

    handleChangeChk_all() {
        this.setState({ chkAll: !this.state.chkAll });
    };

    loadData() {
        this.setState({ onLoading: true });
        let select_month = this.state.chkAll ? 'all' : this.state.select_month;
        this.bind_data(select_month.toString());
    }

    bind_data(month) {
        const state = JSON.parse(window.localStorage.getItem('state'))
        const userid = state.authen.UserID
        const companyid = window.localStorage.getItem('CompanyID')
        const axios = require('axios');
        var Token
        axios.get(Constants.BASE_URL + 'auth/token')
            .then((response) => {
                Token = response.data
                axios.get(Odata_2_Url + 'v_AllReport?Year=' + this.state.select_year + "&Month=" + month,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then((response) => {
                    var data = []
                    data = (response.data || []).chk

                    if (data.length != 0) {
                        this.setState({ company_socard: formatNumber(data[0].companySOCard) })
                        this.setState({ company_target: formatNumber(data[0].companyTarget) })
                        this.setState({ percentSOTCompany: formatNumber(data[0].percentSOTCompany) })

                        this.set_data(data[0].safeNumber, data[0].unSafeNumber);
                        this.setState({ shown: 'block', pieDataTemp: data[0] })

                        axios.get(Odata_2_Url + 'getTop3_all_rep?Year=' + this.state.select_year + "&Month=" + month + "&category=safe",
                            {
                                headers: {
                                    "Authorization": "Bearer " + Token,
                                }
                            }
                        ).then((response) => {
                            var data = []
                            data = response.data
                            this.set_data_bar(data)
                            this.setState({ safeData: data })
                            // this.set_data_bar(data[0].job_detail, data[1].job_detail, data[2].job_detail,
                            //     data[0].jobdetailNumber, data[1].jobdetailNumber, data[2].jobdetailNumber)
                        });

                        axios.get(Odata_2_Url + 'getTop3_all_rep?Year=' + this.state.select_year + "&Month=" + month + "&category=unsafe",
                            {
                                headers: {
                                    "Authorization": "Bearer " + Token,
                                }
                            }
                        ).then((response) => {
                            var data = []
                            data = response.data
                            this.set_data_bar_2(data)
                            this.setState({ unSafeData: data })
                            // this.set_data_bar_2(data[0].job_detail, data[1].job_detail, data[2].job_detail,
                            //     data[0].jobdetailNumber, data[1].jobdetailNumber, data[2].jobdetailNumber)
                        });
                        this.setState({ onLoading: false });
                    }
                    else {
                        this.setState({ shown: 'none' })
                        // alert("ไม่มีข้อมูลที่ท่านเลือก");
                        this.setState({ onLoading: false });
                    }

                    let data_table = (response.data || []).all

                    let observation_All = this.state.company_socard
                    let unsafe_killer = 0
                    let nearmiss = 0
                    let datalist = data_table.map((l, i) => {
                       
                        unsafe_killer += l.unsafeKiller
                        nearmiss += l.nearmiss
                        observation_All += l.transactionNo
                      
                        return l.transactionNo
                    })

                    this.setState({
                        chartdata: {
                            labels: ['JAN', 'FEB', 'MAR', 'APIL', 'MAY', 'JUNE', 'JULY', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                            datasets: [
                                {
                                    label: `My Observation Checklist in ${this.state.select_year}`,
                                    backgroundColor: 'rgba(255,99,132,0.2)',
                                    borderColor: 'rgba(255,99,132,1)',
                                    borderWidth: 1,
                                    hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                    hoverBorderColor: 'rgba(255,99,132,1)',
                                    data: datalist
                                }
                            ]
                        },

                        observation_All: observation_All,
                        unsafe_killer: unsafe_killer,
                        nearmiss: nearmiss

                    })

                },
                    (error) => {
                        this.setState({ onLoading: false });
                        console.log(error)
                    });
            },
                (error) => {
                    this.setState({ onLoading: false });
                    console.log(error)
                }).catch(err => {
                    if (401 === err.response.status) {
                        window.location.href = "auth";
                    }
                });
    }


    render() {
        var min = "2018"
        var max = new Date().getFullYear()
        var month_now = new Date().getMonth();

        var options = []
        for (var i = min; i <= max; i++) {
            options.push(
                <Option value={i} key={i}>{i}</Option>
            )
        }

        let month_options = []
        month_list.map((l, i) => {
            month_options.push(
                <Option value={l.order} key={l.order}>{l.monthName}</Option>
            )
        })

        const { companyFetching, companyData, companyValue, piedata } = this.state
        var hidden = {
            display: this.state.shown
        }
        var barCss = {
            display: this.state.shown,
            margin: '20px'
        }
        var show = {
            display: this.state.shown === 'none' ? 'block' : 'none',
            margin: '20px',
            textAlign: 'center'
        }

        return (

            <div>
                <Spin spinning={this.state.onLoading} size="large" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} tip={<IntlMessages id='Loading' />}>
                    <MenuSider title={<IntlMessages id='menu.dashboard_all' />}>
                        <div style={{ width: "100%", padding: "10px 20px 0 20px", textAlign: "center" }}>
                            <Collapse defaultActiveKey={['1']}>
                                <Panel header={<IntlMessages id='Filter' />} key="1">
                                    <div style={{ width: "100%", padding: "5px 20px 0 20px", textAlign: "center" }}>
                                        <div>
                                            <Row>
                                                <Checkbox
                                                    defaultChecked={this.state.chkAll}
                                                    onChange={this.handleChangeChk_all}
                                                    style={{ margin: "10px 0px 10px 0px" }}
                                                >
                                                    <IntlMessages id='All' />
                                                </Checkbox>
                                                <Select
                                                    style={{ width: 220, margin: "10px 0px 10px 0px" }}
                                                    placeholder="Select months"
                                                    mode="multiple"
                                                    onChange={this.handleChangeMonth} defaultValue={this.state.select_month}
                                                    disabled={this.state.chkAll}
                                                >
                                                    {month_options}
                                                </Select>
                                                &nbsp; &nbsp;
                                            {/* </Row>
                                            <Row> */}
                                                <Select style={{ width: 150, margin: "10px 0px 10px 0px" }} placeholder="Select a year"
                                                    onChange={this.handleChange} defaultValue={max}>
                                                    {options}
                                                </Select>
                                                &nbsp; &nbsp;
                                                <Button onClick={this.loadData} style={{ width: 120, margin: "10px 0px 10px 0px" }}><IntlMessages id='Search' /></Button>
                                            </Row>
                                        </div>
                                    </div>
                                </Panel>
                            </Collapse>
                        </div>
                        <div style={hidden}>
                            {
                                this.state.company_name ? (
                                    <Row>
                                        <Col style={{ textAlign: "center", margin: "20px" }}>
                                            <h4>{this.state.company_name}</h4>
                                        </Col>
                                    </Row>
                                ) : null
                            }

                            {
                                this.state.company_socard ? (

                                    <Row style={{ margin: "20px 0px 0px 0px" }}>
                                        <Col>
                                            <Col md={6} xs={6} style={{ textAlign: "right" }}>
                                                <h4>Company SO Card : </h4>
                                            </Col>
                                            <Col md={6} xs={6}>

                                                <span> {this.state.company_socard}</span>

                                            </Col>
                                        </Col>
                                    </Row>
                                ) : null
                            }

                            {
                                this.state.company_target ? (
                                    <Row>
                                        <Col>
                                            <Col md={6} xs={6} style={{ textAlign: "right" }}>
                                                <h4>Company Target : </h4>
                                            </Col>
                                            <Col md={6} xs={6}>
                                                <span> {this.state.company_target}</span>
                                            </Col>
                                        </Col>
                                    </Row>
                                ) : null
                            }


                            {
                                this.state.percentSOTCompany ? (
                                    <Row>
                                        <Col>
                                            <Col md={6} xs={6} style={{ textAlign: "right" }}>
                                                <h4>% SOT : </h4>
                                            </Col>
                                            <Col md={6} xs={6}>
                                                <span> {this.state.percentSOTCompany} % </span>
                                            </Col>
                                        </Col>
                                    </Row>
                                ) : null
                            }

                        </div>

                        <div style={show}>
                            <span><IntlMessages id='Dashboard.NodataAvailable' /></span>
                        </div>

                        <div style={barCss}>

                            <div className="col-12 web">

                                <div className="col-12">
                                    <div className="col-7" style={{ textAlign: "center", paddingBottom: "3%" }}>
                                        <div className="col-12">
                                            <p style={{ textAlign: "center", fontSize: "18px", marginTop: "15px" }}>Summary safe unsafe of safety obervation tour</p>
                                            <Pie style={{ marginTop: "20px" }} data={this.state.pieData} options={this.state.pieLabel} />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <Row>
                                        <div className="col-5" style={{ textAlign: "center", padding: "3%", paddingLeft: "0px", paddingBottom: "3%" }}>
                                            <div className="col-12">
                                                <p style={{ textAlign: "center", fontSize: "18px" }}>Summary Top 3 Safe of Job</p>
                                                <Bar style={{ marginTop: "20px" }} data={this.state.barData} options={this.state.barLabel} />
                                            </div>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="col-5" style={{ textAlign: "center", padding: "3%", paddingLeft: "0px", paddingBottom: "3%" }}>
                                            <div className="col-12">
                                                <p style={{ textAlign: "center", fontSize: "18px" }}>Summary Top 3 UnSafe of Job</p>
                                                <Bar style={{ marginTop: "20px" }} data={this.state.barData_2} options={this.state.barLabel} />
                                            </div>
                                        </div>
                                    </Row>

                                </div>

                            </div>

                            <div className="Chart-bar" style={{ paddingTop: "15px" }}>
                                <Bar
                                    ref="chart"
                                    data={this.state.chartdata}
                                    options={{
                                        title: {
                                            text: 'Largest Cities In ',
                                            fontSize: 25
                                        },
                                        legend: {
                                            display: "Massachusetts",
                                            position: "top"
                                        },
                                        plugins: {
                                            labels: {
                                                render: 'value'
                                            }
                                        },
                                        scales: {
                                            yAxes: [{
                                                ticks: {
                                                    beginAtZero: true,
                                                }
                                            }],
                                            xAxes: [{
                                                ticks: {
                                                    autoSkip: false,
                                                    autoSkipPadding: 20,
                                                    maxRotation: 90,
                                                    minRotation: 90
                                                },
                                                maxBarLength: 2,
                                                maxBarThinckness: 8,
                                            }]
                                        },

                                        // maintainAspectRatio: false  
                                    }}
                                />
                            </div>

                            <div style={{ width: "100%" }}>
                                <div className="Observation_All" style={{ width: "33%", display: "inline-block", textAlign: "center" }}>
                                    <div>
                                        <IntlMessages id='Dashboard.Observation' />
                                    </div>
                                    <div style={{ fontSize: "25px" }}>
                                        {this.state.company_socard}
                                    </div>
                                </div>
                                <div className="Unsefe-killer" style={{ width: "33%", display: "inline-block", textAlign: "center" }}>
                                    <div>
                                        <IntlMessages id='Dashboard.UnsafeKiller' />
                                    </div>
                                    <div style={{ fontSize: "25px" }}>
                                        {this.state.unsafe_killer}
                                    </div>
                                </div>
                                <div className="Near-miss" style={{ width: "34%", display: "inline-block", textAlign: "center" }}>
                                    <div>
                                        <IntlMessages id='Dashboard.NearMiss' />
                                    </div>
                                    <div style={{ fontSize: "25px" }}>
                                        {this.state.nearmiss}
                                    </div>
                                </div>

                            </div>
                        </div>

                    </MenuSider>
                </Spin>
            </div>
        )
    }




}